
import { QUESTIONS } from '../../data/questions'
import { calcProfile } from '../../utils/calcProfile'

const state = {
  questions: QUESTIONS,
  answers: {},
  result: null
}

const getters = {
  answeredCount: s => Object.keys(s.answers).length
}

const mutations = {
  SET_ANSWER (s, { qId, option }) { s.answers = { ...s.answers, [qId]: option } },
  SET_RESULT (s, profile) { s.result = profile }
}

const actions = {
  saveAnswer ({ commit }, payload) { commit('SET_ANSWER', payload) },
  calculate ({ state, commit }) {
    if (Object.keys(state.answers).length !== state.questions.length) return
    const profile = calcProfile(Object.values(state.answers))
    console.log(profile )
    commit('SET_RESULT', profile)
  },
  reset ({ commit }) { commit('SET_RESULT', null); commit('SET_ANSWER', {}) }
}

export default { namespaced: true, state, getters, mutations, actions }
